import { Trans } from '@lingui/react/macro'
import { Locale, setLocale } from '$src/lib/i18n'
import { trpcClient } from '$src/lib/trpc'
import { authHooks } from '$src/lib/trpcHooks'
import { useAuthStore } from '$src/store/useAuthStore'
import { getAttributionPayload } from '$src/utils/utm'
import { Center, Loader, Stack, Text } from '@mantine/core'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect } from 'react'

export function GoogleCallback() {
  const search = useSearch({ from: '/auth/google/callback' })
  const navigate = useNavigate()
  const { setUser } = useAuthStore()
  const { mutateAsync: verifyGoogleCallback } = authHooks.useGoogleCallback()

  useEffect(() => {
    const code = search.code
    const error = search.error

    if (error) {
      navigate({ to: '/', replace: true })
      return
    }

    if (!code) {
      navigate({ to: '/', replace: true })
      return
    }

    verifyGoogleCallback({
      code,
      app: 'resident',
      attribution: getAttributionPayload(),
    })
      .then(async () => {
        // Fetch user data to populate auth store
        const userData = await trpcClient.user.me.query()
        setLocale(userData.uiLanguage as Locale)
        setUser(userData)
        // Navigate to home page after successful login
        navigate({ to: '/home', replace: true })
      })
      .catch(() => {
        navigate({ to: '/', replace: true })
      })
  }, [search, navigate, verifyGoogleCallback, setUser])

  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Text c="dimmed">
          <Trans>Signing in...</Trans>
        </Text>
      </Stack>
    </Center>
  )
}
